//ApproveVoteService.ts
import { axiosRequest } from "./AxiosService";
import { ApplicationData } from "../pages/RecordDetail/ApplicationData";

/**
 * 進行中のアクティビティIDを取得する
 * @param applicationData - 申請データ
 * @returns 進行中のアクティビティID、存在しない場合はnull
 */
export const getCurrentActivityId = (applicationData: ApplicationData) => {
    if (!applicationData.activityList || applicationData.activityList.length === 0) {
        return null;
    }

    // 申請ステータスは進行中のアクションを見つけ出す
    const activityId = applicationData.activityList.find(
        activity => activity.status === "InProgress"
    )?.activityId;

    // 該当するアクティビティが存在しない場合
    if (!activityId) {
        console.warn("進行中のアクティビティが存在しません。");
    }

    return activityId || null;
};

/**
 * 承認処理（approveVote）
 * ログイン中のユーザーID（userId）と進行中のアクティビティID（activityId）を獲得。
 * @param userId - 現在のユーザーのID
 * @param applicationData - 進行中のアクティビティを特定するために使用される。
 */

export const approveVote = async (userId: string, applicationData: ApplicationData,comment:string): Promise<boolean> => {
    // ログイン中のuserIdと進行中のactivityIdを獲得
    const activityId = getCurrentActivityId(applicationData);
  
    // userIdとactivityIdを獲得できない場合
    if (!userId || !activityId) {
      console.error("ユーザーIDまたはアクティビティIDが無効です");
      return false;
    }
  
    // 引数を設定する
    const options = {
      data: {
        userId: userId,
        activityId: activityId,
        comment:comment
      },
    };
  
    try {
      // サーバー通信
      const response: Promise<boolean> = axiosRequest(
        "/vote/approveVote",  
        "POST",                   
        options                 
      );
  
      
      if (response !== undefined) {
        return (await response).valueOf();
      } else {
        return false;
      }
    } catch (error) {
     
      console.error("承認処理のリクエストエラー:", error);
      return false;
    }
  };